import React from 'react';
import { motion } from 'framer-motion';
import { FaExternalLinkAlt, FaMusic, FaUsers, FaReact } from 'react-icons/fa';

const itemVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.5, ease: 'easeOut' },
  },
};

const features = [
  '網頁版卡拉OK，免安裝即可使用',
  '上架僅 2 天即突破 2,000 人次造訪',
  '簡潔直覺的操作介面',
  '支援多種歌曲來源播放與同步調整功能',
];

const KaraOKShowcase = () => {
  return (
    <motion.div
      variants={itemVariants}
      className="mb-16 rounded-2xl border border-secondary-800/30 bg-gradient-to-br from-slate-800/60 to-slate-900/60 overflow-hidden"
    >
      {/* 頂部標籤列 */}
      <div className="flex items-center justify-between px-6 py-4 border-b border-white/10">
        <div className="flex items-center gap-3">
          <span className="inline-block px-3 py-0.5 rounded-full bg-secondary-900/50 text-secondary-400 text-xs font-medium border border-secondary-800/40">
            精選展示
          </span>
          <h3 className="text-lg font-bold">KarOK Studio</h3>
          <span className="inline-flex items-center gap-1 px-2.5 py-0.5 rounded-full bg-amber-900/30 text-amber-400 text-xs font-medium border border-amber-800/30">
            <FaUsers className="text-[10px]" />
            2,000+ 人次
          </span>
        </div>
        <a
          href="https://karok.kaienet.work/"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-slate-800/80 text-sm font-medium hover:bg-secondary-600 transition-colors"
        >
          <FaExternalLinkAlt />
          前往網站
        </a>
      </div>

      <div className="grid lg:grid-cols-3 gap-0">
        {/* 左側：專案資訊 */}
        <div className="p-6 border-r border-white/10">
          <p className="text-gray-300 text leading-relaxed mb-5">
            網頁版卡拉OK工具，讓使用者無需安裝任何軟體即可在瀏覽器中享受卡拉OK體驗。上架僅兩天即突破 2,000 人次造訪，深受使用者喜愛。
          </p>

          <ul className="space-y-2.5 mb-6">
            {features.map((f, i) => (
              <li key={i} className="flex items-start gap-2.5 text-gray-300 text">
                <span className="mt-1.5 w-1.5 h-1.5 rounded-full bg-secondary-500 shrink-0"></span>
                {f}
              </li>
            ))}
          </ul>

          <div className="flex flex-wrap gap-2">
            {[
              { icon: <FaMusic className="text-pink-400" />, label: 'Karaoke' },
              { icon: <FaReact className="text-blue-400" />, label: 'Web App' },
              { icon: <FaUsers className="text-amber-400" />, label: '2K+ Users' },
            ].map(({ icon, label }) => (
              <span key={label} className="flex items-center gap-1 px-2.5 py-1 rounded-full bg-slate-800/60 text-xs font-medium">
                {icon} {label}
              </span>
            ))}
          </div>
        </div>

        {/* 右側：大圖展示 */}
        <div className="lg:col-span-2 p-6 flex items-center justify-center bg-slate-900/30">
          <motion.div
            initial={{ opacity: 0, scale: 0.97 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.3 }}
            className="w-full rounded-xl overflow-hidden border border-white/10 shadow-2xl shadow-black/40"
          >
            <img
              src="/images/karok.png"
              alt="KarOK Studio 網頁卡拉OK"
              className="w-full h-auto"
            />
          </motion.div>
        </div>
      </div>
    </motion.div>
  );
};

export default KaraOKShowcase;
